import { apiErrorLogger } from './apiErrorLogger';

const isPromise = <T>(value: unknown): value is Promise<T> => value instanceof Promise;

export const withApiErrorCapture =
  <Args extends readonly unknown[], Return>(fn: (...args: Args) => Return) =>
  (...args: Args): Return => {
    try {
      const result = fn(...args);

      if (isPromise(result)) {
        return (result as Promise<unknown>).catch((e: unknown) => {
          apiErrorLogger(e);
          throw e;
        }) as Return;
      }

      return result;
    } catch (e) {
      apiErrorLogger(e);
      throw e;
    }
  };
